import { mapGetters } from 'vuex';

export const PermissionMixin = (inputData = null) => ({
    computed: {
        ...mapGetters(['ability']),

        accessibleItems() {
            if (!inputData) return;

            let list;

            /*
            *
            * inputData can be a function, which expect "this" context in to parameters,
            * for this case there is condition checking, is inputData is a function
            * */
            if (_.isFunction(inputData)) {
                let vm = this;
                list = inputData(vm);
            } else {
                list = _.isString(inputData) ? this[inputData] : inputData;
            }

            return list.filter(i => this.hasAccess(i));
        }
    },

    methods: {
        /*
        *
        * item can be object from config file with permission parameter
        * or array with first item -> list of rules and second -> resource name
        * it make sense if we simply checking permissions in template,
        * instead of passing whole item like in first case
        * */
        hasAccess(item) {
            if (!item || !this.ability) return false;

            return this.ability.can(..._.isArray(item)
                ? [item[0], item[1]]
                : [item.permission.rules, item.permission.name]);
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/PermissionMixin.js